module.exports = __webpack_public_path__ + "杨伟健-95a9be84.png";